import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const AccessGroupsTableColumns: ITableColumn[] = [
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.groupName',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.Text,
    width: 260,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'name',
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.members',
    propertyKey: 'members',
    colType: TableColumnTypeEnum.Number,
    width: 110,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'members',
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.createdBy',
    propertyKey: 'createdBy',
    colType: TableColumnTypeEnum.Avatar,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'created_by',
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.createdAt',
    propertyKey: 'createdAt',
    colType: TableColumnTypeEnum.DateTime,
    width: 190,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'created_at',
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.lastChanged',
    propertyKey: 'lastChanged',
    colType: TableColumnTypeEnum.DateTime,
    width: 190,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'last_changed',
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.users',
    propertyKey: 'users',
    colType: TableColumnTypeEnum.AvatarsList,
    width: 160,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.role',
    propertyKey: 'role',
    colType: TableColumnTypeEnum.Tag,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'role',
  },
  {
    labelPath: 'userManagementPage.accessGroupsPage.tableColumns.integrations',
    propertyKey: 'integrations',
    colType: TableColumnTypeEnum.Text,
    width: 280,
    widthType: WidthType.Pixel,
    isSortable: false,
    tooltipDynamicText: 'integrations',
    tooltipClass: 'integrations-tooltip-container',
  },
];
